'use strict';

angular.module('TurneroApp').service('generalService', ['$resource', 'portal',  function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/General/:id', { id: '@Id' }, {
    	Get_Server_Id: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/General/Get_Server_Id/'
    	},
    	Get_Version: {
    		method: 'GET',
    		url: portal.getUrlServer() + 'api/General/Get_Version/'
    	},
    	Errores_Post:{
    		method: 'POST',
    		url: portal.getUrlServer() + 'api/General/Errores_Post/'
    		//params: string Mensaje, string Trace, string Object
    	},
    	Errores_Get: {
    		method: 'GET',
    		url: portal.getUrlServer() + 'api/General/Errores_Get/'
    	},
        Cambiar_Usuario_Representado: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/General/CambiarUsuarioRepresentado'
        },
        Limpiar_Datos_Sin_Cerrar_Sesion_CiDi: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/General/LimpiarDatosSinCerrarSesionCiDi'
        }			
    });
}]);


// WEBPACK FOOTER //
// ./app/components/general/generalService.js